/* ═══════════════════════════════════════════════════════════════
   DEAR MUSCLES — theme behaviour
   Cart runs on Shopify's AJAX Cart API (/cart/*.js). Header, footer
   and every section are Liquid — this file only handles behaviour.
   ═══════════════════════════════════════════════════════════════ */

/* ---------- shape dividers ---------- */
const DM_SHAPES = {
  arc:{ bot:['M0,74 Q720,-16 1440,74 L1440,80 L0,80 Z'],
        top:['M0,0 L1440,0 L1440,8 Q720,96 0,8 Z']},
  layered:{
    bot:[['M0,26 C250,72 500,-8 760,18 C1020,44 1240,68 1440,34 L1440,80 L0,80 Z',.38],
         ['M0,48 C240,92 480,8 720,32 C960,56 1200,92 1440,58 L1440,80 L0,80 Z',1]],
    top:[['M0,0 L1440,0 L1440,46 C1240,12 1020,36 760,62 C500,88 250,8 0,54 Z',.38],
         ['M0,0 L1440,0 L1440,24 C1200,60 960,2 720,26 C480,50 240,-4 0,30 Z',1]]},
  bolt:{
    bot:['M0,36 L96,60 L192,20 L288,58 L384,18 L480,56 L576,16 L672,54 L768,14 L864,52 '+
         'L960,18 L1056,58 L1152,22 L1248,60 L1344,26 L1440,48 L1440,80 L0,80 Z'],
    top:['M0,0 L1440,0 L1440,42 L1344,18 L1248,54 L1152,16 L1056,52 L960,14 L864,50 '+
         'L768,12 L672,48 L576,10 L480,46 L384,14 L288,52 L192,18 L96,54 L0,26 Z']}
};
function dmPaintDividers(root){
  (root||document).querySelectorAll('.shape').forEach(s=>{
    if(s.dataset.done) return; s.dataset.done='1';
    const pos = s.dataset.pos || 'bot';
    const style = DM_SHAPES[s.dataset.shape] ? s.dataset.shape : 'arc';
    const fill = s.dataset.fill || 'var(--cream)';
    s.innerHTML = `<svg viewBox="0 0 1440 80" preserveAspectRatio="none">${
      DM_SHAPES[style][pos].map(p=>{
        const [d,op] = Array.isArray(p)?p:[p,1];
        return `<path d="${d}" fill="${fill}" opacity="${op}"/>`;
      }).join('')}</svg>`;
  });
}

/* ---------- thunder headline ---------- */
const DM_BOLT = 'M58,0 L12,60 L41,60 L28,116 L80,46 L50,46 Z';
function dmPaintThunder(root){
  (root||document).querySelectorAll('[data-thunder]').forEach(el=>{
    if(el.dataset.done) return; el.dataset.done='1';
    el.classList.add('thunder');
    const txt = el.textContent;
    /* RogCare: accent word only — the gym-brand bolt and glow are gone. */
    el.innerHTML = `<span class="tx">${txt}</span>`;
  });
}

/* ---------- gym stickers ---------- */
const DM_STICKERS = {
  dumbbell:`<svg viewBox="0 0 120 60"><g stroke="var(--ink)" stroke-width="5" stroke-linejoin="round">
    <rect x="34" y="24" width="52" height="12" rx="3" fill="var(--gold)"/>
    <rect x="18" y="12" width="16" height="36" rx="4" fill="var(--navy)"/>
    <rect x="86" y="12" width="16" height="36" rx="4" fill="var(--navy)"/>
    <rect x="6" y="19" width="12" height="22" rx="4" fill="var(--gold)"/>
    <rect x="102" y="19" width="12" height="22" rx="4" fill="var(--gold)"/></g></svg>`,
  kettlebell:`<svg viewBox="0 0 80 92"><g stroke="var(--ink)" stroke-width="5" stroke-linejoin="round">
    <path d="M26 34c0-16 6-26 14-26s14 10 14 26" fill="none"/>
    <path d="M40 32c18 0 30 14 30 32 0 12-8 22-30 22S10 76 10 64c0-18 12-32 30-32Z" fill="var(--gold)"/>
    <ellipse cx="40" cy="62" rx="13" ry="11" fill="var(--navy)"/></g></svg>`,
  plate:`<svg viewBox="0 0 84 84"><g stroke="var(--ink)" stroke-width="5">
    <circle cx="42" cy="42" r="37" fill="var(--navy)"/><circle cx="42" cy="42" r="13" fill="var(--cream)"/>
    <circle cx="42" cy="42" r="25" fill="none" stroke-width="3.5" opacity=".5"/></g></svg>`,
  bicep:`<svg viewBox="0 0 96 84"><g stroke="var(--ink)" stroke-width="5" stroke-linejoin="round">
    <path d="M12 62c0-22 12-38 32-38 14 0 22 8 26 18 3 8 12 6 16 14 4 9-2 20-14 20H24c-8 0-12-6-12-14Z" fill="var(--gold)"/>
    <path d="M30 44c8-6 18-6 26 2" fill="none" stroke-width="4"/>
    <rect x="8" y="58" width="26" height="20" rx="7" fill="var(--navy)"/></g></svg>`,
  scoop:`<svg viewBox="0 0 84 84"><g stroke="var(--ink)" stroke-width="5" stroke-linejoin="round">
    <path d="M14 34h44v22c0 10-10 18-22 18s-22-8-22-18V34Z" fill="var(--gold)"/>
    <path d="M58 40h8c6 0 10-5 10-11s-4-11-10-11" fill="none"/>
    <path d="M14 34c0-7 10-12 22-12s22 5 22 12" fill="var(--cream)"/></g></svg>`,
  shaker:`<svg viewBox="0 0 62 92"><g stroke="var(--ink)" stroke-width="5" stroke-linejoin="round">
    <rect x="10" y="24" width="42" height="60" rx="9" fill="var(--navy)"/>
    <rect x="14" y="6" width="34" height="18" rx="6" fill="var(--gold)"/>
    <path d="M10 54h42" stroke-width="4"/></g></svg>`,
  bolt:`<svg viewBox="0 0 60 86"><path d="M38 3 8 48h20L20 83 54 34H32L38 3Z"
    fill="var(--gold)" stroke="var(--ink)" stroke-width="5" stroke-linejoin="round"/></svg>`,
  fire:`<svg viewBox="0 0 66 84"><g stroke="var(--ink)" stroke-width="5" stroke-linejoin="round">
    <path d="M33 4c14 16 26 24 26 44 0 18-12 32-26 32S7 66 7 48C7 32 21 26 33 4Z" fill="var(--navy)"/>
    <path d="M33 40c6 8 12 12 12 22 0 9-5 14-12 14s-12-5-12-14c0-8 7-13 12-22Z" fill="var(--gold)"/></g></svg>`,
  trophy:`<svg viewBox="0 0 78 88"><g stroke="var(--ink)" stroke-width="5" stroke-linejoin="round">
    <path d="M18 8h42v26c0 13-9 22-21 22S18 47 18 34V8Z" fill="var(--gold)"/>
    <path d="M18 14H8c0 14 5 20 12 22M60 14h10c0 14-5 20-12 22" fill="none"/>
    <path d="M32 56h14v12H32z" fill="var(--navy)"/><rect x="20" y="68" width="38" height="12" rx="4" fill="var(--navy)"/></g></svg>`,
  sparkle:`<svg viewBox="0 0 44 44"><path d="M22 2c2 12 8 18 20 20-12 2-18 8-20 20-2-12-8-18-20-20 12-2 18-8 20-20Z"
    fill="var(--gold)" stroke="var(--ink)" stroke-width="3.5" stroke-linejoin="round"/></svg>`,
  squiggle:`<svg viewBox="0 0 190 30"><path d="M4 22c22-22 42 6 62-4s34-18 56-6 40 8 64-4"
    fill="none" stroke="var(--navy)" stroke-width="5" stroke-linecap="round"/></svg>`,
  arrow:`<svg viewBox="0 0 96 62"><g fill="none" stroke="var(--navy)" stroke-width="5" stroke-linecap="round">
    <path d="M6 12c26 0 56 8 74 34"/><path d="M62 44l20 4-6-20"/></g></svg>`
};
function dmPaintStickers(root){
  (root||document).querySelectorAll('[data-stk]').forEach(el=>{
    if(el.dataset.done) return; el.dataset.done='1';
    el.innerHTML = DM_STICKERS[el.dataset.stk] || '';
  });
}
function dmSeal(el, text){
  el.innerHTML = `<svg viewBox="0 0 120 120">
    <defs><path id="dmSealPath" d="M60,60 m-42,0 a42,42 0 1,1 84,0 a42,42 0 1,1 -84,0"/></defs>
    <circle cx="60" cy="60" r="52" fill="var(--gold)" stroke="var(--ink)" stroke-width="4"/>
    <circle cx="60" cy="60" r="33" fill="var(--cream)" stroke="var(--ink)" stroke-width="3"/>
    <g class="ring"><text><textPath href="#dmSealPath" startOffset="0">${text}</textPath></text></g>
    <g transform="translate(45,38) scale(.34)">${DM_STICKERS.bolt}</g></svg>`;
}

/* ═══════════════ CART — Shopify AJAX API ═══════════════ */
const DM = {
  money(cents){
    const v = (cents/100);
    return '₹' + v.toLocaleString('en-IN', {maximumFractionDigits: v % 1 ? 2 : 0});
  },
  async get(){ const r = await fetch('/cart.js'); return r.json(); },
  async add(variantId, qty){
    const r = await fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id:Number(variantId), quantity:Number(qty)||1}]})
    });
    if(!r.ok){ const e = await r.json().catch(()=>({})); throw new Error(e.description||'Could not add to cart'); }
    return r.json();
  },
  async change(key, qty){
    const r = await fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:key, quantity:Number(qty)})
    });
    return r.json();
  }
};

/* every ATC on every section routes through here */
async function dmAtc(btn, variantId, qty){
  if(!variantId){ return; }
  const label = btn ? btn.textContent : '';
  if(btn){ btn.disabled = true; btn.textContent = 'ADDING…'; }
  try{
    await DM.add(variantId, qty);
    const cart = await DM.get();
    dmRenderCart(cart);
    dmToast(cart);
    dmOpenCart();
    if(btn){ btn.classList.add('added'); btn.textContent = '✓ ADDED'; }
  }catch(err){
    if(btn){ btn.textContent = 'UNAVAILABLE'; }
    console.warn('[dm] add to cart failed:', err.message);
  }finally{
    if(btn) setTimeout(()=>{ btn.disabled=false; btn.classList.remove('added'); btn.textContent=label; }, 1600);
  }
}

function dmCartCount(cart){
  document.querySelectorAll('.cart-dot').forEach(d=>{
    d.textContent = cart.item_count;
    d.style.display = cart.item_count ? 'grid' : 'none';
  });
}

function dmRenderCart(cart){
  dmCartCount(cart);
  const body = document.getElementById('dmCartBody');
  const foot = document.getElementById('dmCartFoot');
  if(!body) return;

  if(!cart.items.length){
    body.innerHTML = `<div class="dw-empty"><div class="e">🛒</div>
      <h3 style="font-size:18px;margin-bottom:7px">Your cart is empty</h3>
      <p style="margin:0 0 18px;font-size:13.5px">Nothing in here yet.</p>
      <a class="btn btn-stk" href="/collections/all">SHOP ALL PRODUCTS →</a></div>`;
    foot.innerHTML = '';
    return;
  }

  body.innerHTML = cart.items.map(i=>`
    <div class="dl">
      <a class="dl-img" href="${i.url}"><img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2') : ''}" alt=""></a>
      <div class="dl-b">
        <a href="${i.url}"><h4>${i.product_title}</h4></a>
        ${i.variant_title && i.variant_title !== 'Default Title' ? `<div class="fl">${i.variant_title}</div>` : ''}
        <div class="dl-q">
          <button onclick="dmQty('${i.key}',${i.quantity-1})" aria-label="Less">−</button>
          <span>${i.quantity}</span>
          <button onclick="dmQty('${i.key}',${i.quantity+1})" aria-label="More">+</button>
        </div>
      </div>
      <div class="dl-r"><div class="dl-p">${DM.money(i.final_line_price)}</div>
        <button class="dl-x" onclick="dmQty('${i.key}',0)">Remove</button></div>
    </div>`).join('');

  const free = Number(document.body.dataset.freeShip || 99900);
  const need = Math.max(0, free - cart.total_price);
  const pct  = Math.min(100, (cart.total_price/free)*100);
  const saved = cart.items.reduce((s,i)=>
    s + Math.max(0, (i.original_line_price - i.final_line_price)), 0);

  foot.innerHTML = `
    <div class="dw-ship">${need>0
      ? `Add <b>${DM.money(need)}</b> more for FREE shipping`
      : `🎉 You've unlocked <b>free shipping</b>`}
      <div class="track"><i style="width:${pct}%"></i></div></div>
    <div class="dw-row"><span>Subtotal</span><span>${DM.money(cart.items_subtotal_price)}</span></div>
    ${saved>0?`<div class="dw-row"><span>You save</span>
      <span style="color:var(--ok);font-weight:700">− ${DM.money(saved)}</span></div>`:''}
    <div class="dw-row tot"><span>Total</span><span>${DM.money(cart.total_price)}</span></div>
    <a class="btn btn-stk btn-lg" style="width:100%;margin-top:12px" href="/checkout">CHECKOUT →</a>
    <button class="btn btn-ghost btn-sm" style="width:100%;margin-top:8px"
      onclick="dmCloseDrawers()">CONTINUE SHOPPING</button>`;
}
async function dmQty(key, q){
  const cart = await DM.change(key, q);
  dmRenderCart(cart);
}

/* ---------- compact toast ---------- */
let dmToastT;
function dmToast(cart){
  const last = cart.items[0];
  if(!last) return;
  let t = document.querySelector('.toast');
  if(!t){ t = document.createElement('div'); t.className='toast'; document.body.appendChild(t); }
  t.innerHTML = `<img src="${last.image ? last.image.replace(/(\.[a-z]+)(\?|$)/i,'_80x$1$2') : ''}" alt="">
    <span class="t">Added · ${last.product_title}</span>
    <button onclick="dmOpenCart()">VIEW CART</button>`;
  requestAnimationFrame(()=>t.classList.add('on'));
  clearTimeout(dmToastT);
  dmToastT = setTimeout(()=>t.classList.remove('on'), 3200);
}

/* ---------- drawers ---------- */
function dmOpenDrawer(id){
  document.getElementById(id)?.classList.add('on');
  document.getElementById('dmScrim')?.classList.add('on');
  document.body.style.overflow='hidden';
}
function dmCloseDrawers(){
  document.querySelectorAll('.dm-drawer').forEach(d=>d.classList.remove('on'));
  document.getElementById('dmScrim')?.classList.remove('on');
  document.getElementById('dmBurger')?.classList.remove('on');
  document.body.style.overflow='';
}
function dmOpenCart(){ dmOpenDrawer('dmCartDrawer'); }
function dmToggleNav(){
  const d = document.getElementById('dmNavDrawer');
  const b = document.getElementById('dmBurger');
  if(!d) return;                       // drawer markup missing — do nothing, don't throw
  if(d.classList.contains('on')) dmCloseDrawers();
  else { if(b) b.classList.add('on'); dmOpenDrawer('dmNavDrawer'); }
}

/* ---------- rails: dot indicators + optional auto-rotate ---------- */
function dmWireRails(root){
  (root||document).querySelectorAll('[data-dots]').forEach(rail=>{
    const dots = document.getElementById(rail.dataset.dots);
    if(!dots || dots.dataset.done) return;
    dots.dataset.done = '1';
    const n = rail.children.length;
    dots.innerHTML = Array.from({length:n},(_,i)=>`<i class="${i?'':'on'}"></i>`).join('');
    rail.addEventListener('scroll', ()=>{
      const i = Math.round(rail.scrollLeft / (rail.scrollWidth/n));
      [...dots.children].forEach((d,k)=>d.classList.toggle('on', k===Math.min(i,n-1)));
    }, {passive:true});
  });
  (root||document).querySelectorAll('[data-autorotate]').forEach(rail=>{
    if(rail.dataset.rotating) return;
    rail.dataset.rotating = '1';
    let paused = false, i = 0;
    const step = () => rail.firstElementChild
      ? rail.firstElementChild.getBoundingClientRect().width + 20 : 320;
    ['mouseenter','touchstart','focusin'].forEach(e=>
      rail.addEventListener(e, ()=>paused=true, {passive:true}));
    ['mouseleave','touchend'].forEach(e=>
      rail.addEventListener(e, ()=>paused=false, {passive:true}));
    setInterval(()=>{
      if(paused || !rail.children.length) return;
      const max = rail.scrollWidth - rail.clientWidth;
      i = (rail.scrollLeft >= max - 4) ? 0 : i + 1;
      rail.scrollTo({left: Math.min(i*step(), max), behavior:'smooth'});
    }, Number(rail.dataset.autorotate) || 3200);
  });
}
function dmRailScroll(id, dir){
  const r = document.getElementById(id);
  if(r) r.scrollBy({left: dir * Math.round(r.clientWidth * 0.7), behavior:'smooth'});
}

/* ---------- boot ---------- */
function dmBoot(root){
  dmPaintDividers(root);
  dmPaintThunder(root);
  dmPaintStickers(root);
  dmWireRails(root);
}
document.addEventListener('DOMContentLoaded', ()=>{
  dmBoot();
  DM.get().then(dmRenderCart).catch(()=>{});
  document.addEventListener('keydown', e=>{ if(e.key==='Escape') dmCloseDrawers(); });
});

/* The inline onclick attributes are the only binding. An earlier delegated
   listener here fired *in addition* to them, so every burger click ran
   dmToggleNav twice — open, then straight back closed. Don't reintroduce it
   without removing the inline handlers first. */
/* theme editor: re-init when a section is re-rendered */
document.addEventListener('shopify:section:load', e=>dmBoot(e.target));
